import React, { useState, useEffect } from 'react';

const PlausibleData = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const isDarkMode = localStorage.getItem('darkMode');
    if (isDarkMode) {
      setTheme('dark');
    }
  }, []);

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 relative overflow-hidden">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white dark:bg-gray-800 z-10">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        )}

        <iframe
          plausible-embed="true"
          src={`https://plausible.io/share/bi.globe-groupe.com?auth=mRb2fJWgKrbi4cxcAUHuB&embed=true&theme=${theme}`}
          scrolling="yes"
          frameBorder="0"
          loading="lazy"
          className="w-full h-full"
          title="Plausible Analytics"
          onLoad={() => setIsLoading(false)}
        />
        <script async src="https://plausible.io/js/embed.host.js"></script>
      </div>
    </div>
  );
};

export default PlausibleData;